import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AdminToolbar from '../../Toolbar/AdminToolbar';
import EditorToolbar from '../../Toolbar/EditorToolbar';
import { Box, Tab, Tabs } from '@mui/material';
import AdminSavedPostAnalytics from './AdminSavedPostAnalytics';
import AdminPageClick from './AdminPageClick';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AdminAnalytics = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState(null);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const getUserFromCookie = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
          withCredentials: true,
        });
        const { user, username } = res.data;
        if (username && (user === 'Admin')) {
          setUserType(user);
          setUsername(username);
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error('Error checking login:', err);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    getUserFromCookie();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;

  return (
    <>
     
      {userType === 'Admin' && (
            <>
            <AdminToolbar/>
             <div className="form-container-1">
            <Box sx={{ width: '100%', borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleTabChange} aria-label="permission tabs" >
                <Tab label="Posts by Saved Posts"/>
                <Tab label="Posts by Clicks"/>
                {/* <Tab label="Posts by Categories"/> */}
                </Tabs>
                {value === 0 && <AdminSavedPostAnalytics/>} 
                {value === 1 && <AdminPageClick/>} 
                {/* {value === 2}  */}
        </Box>
      </div>
            </>
          )}
    </>
  );
};

export default AdminAnalytics;
